export default __webpack_public_path__ + "static/media/skovstykket-floorplans-apartment-4-12.6802c2f4.jpg";